var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-flex flex-column align-items-center"},[_c('button',{staticClass:"btn-circle btn-line mb-1",on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{staticClass:"tmlps-icn-menu h2 m-0"})]),_c('div',{staticClass:"small text-center"},[_vm._v(_vm._s(_vm.$t('lang.menu.msg')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }